module.exports = __webpack_public_path__ + "static/media/mulher_r2_c1.78ec6ece.jpg";